import * as React from 'react';
import { useMutation, useQuery } from '@apollo/client';
import { userAppMetadataQuery } from '../../graphql/queries';
import { useState } from 'react';
import { resendValidationEmail as resendValidationEmailMutation } from '../../graphql/mutations';
import Button from '../../components/Button';
import LoadingSpinner from '../../components/LoadingSpinner';

type EmailValidationProps = {
  pickpackId: string | null;
};

export const EmailValidationTab = function EmailValidationTab({
  pickpackId,
}: EmailValidationProps) {
  if (pickpackId == null) {
    return <span>No pickpack id for user</span>;
  }

  const { data = { user: null }, loading } = useQuery(userAppMetadataQuery, {
    variables: { id: pickpackId },
    onCompleted: (userData) => {
      //@ts-ignore
      if (
        userData == null ||
        userData.user == null ||
        userData.user.app_metadata == null
      ) {
        return <span>Error loading user with pickpack id {pickpackId}</span>;
      }
      //@ts-ignore
      const appMetadata = JSON.parse(userData.user.app_metadata);
      setValidationToken(appMetadata.mail_validation_token);
    },
  });

  const [resendValidationEmail, { loading: updating }] = useMutation(
    resendValidationEmailMutation,
  );
  const [validationToken, setValidationToken] = useState(null);
  return loading ? (
    <LoadingSpinner />
  ) : (
    <div>
      <div style={{ marginBottom: '1.5em' }}>
        {validationToken ? (
          <span>
            <b>Validation link:</b>{' '}
            {`https://app.vytal.org/verify/vytal?code=${validationToken}&id=${pickpackId}`}
          </span>
        ) : (
          <span>
            Please resend the validation email to generate the validation link
          </span>
        )}
      </div>
      <Button
        small={false}
        disabled={updating}
        loading={updating}
        onClick={() =>
          resendValidationEmail({
            variables: {
              userId: pickpackId,
            },
            refetchQueries: [
              {
                query: userAppMetadataQuery,
                variables: {
                  id: pickpackId,
                },
              },
            ],
          })
        }
      >
        Resend Validation Mail
      </Button>
    </div>
  );
};
